import React from "react";
import { SubHeading as TemplateSubHeading } from "../Typography/typography.styled";
import styled from "styled-components";
import { Container } from "react-bootstrap";

const Subheading = styled(TemplateSubHeading)`
  text-align: center;
  text-transform: uppercase;
  color: #6415ff;
  letter-spacing: 0.1rem;
  font-size: 1rem;
  margin-top: 4rem;

  @media (min-width: 768px) {
    text-align: left;
    margin-top: 0rem;
    margin-bottom: 0rem;
  }
`;

const SectionHeader = ({ title = "SectionTitle" }) => {
  return (
    <div className="py-3">
      <Container className="d-flex justify-content-center">
        <Subheading>{title}</Subheading>
      </Container>
    </div>
  );
};

export default SectionHeader;
